/** @jsx $jsx */
import { $jsx } from 'framework7';
import { setup } from '../../js/sandbox_scripts/template';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $on = _ref.$on;
  $on('pageInit', function (e, page) {
    setup();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
    <div class="page" data-name="environment">
        <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner sliding">
                <div class="title">Environment</div>
            </div>
        </div>
        <div class="page-content">
            <div class="container pt-2">
                <h3>Environment Builder</h3>

                <div class="block-title">Control</div>
                <div class="card p-2">
                    <p>This is under construction</p>
                </div>
            </div>
        </div>
    </div>
`
    }
    ;
});